import { render, staticRenderFns } from "./InComfor.vue?vue&type=template&id=7a943f81&scoped=true"
import script from "./InComfor.vue?vue&type=script&lang=js"
export * from "./InComfor.vue?vue&type=script&lang=js"
import style0 from "./InComfor.vue?vue&type=style&index=0&id=7a943f81&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a943f81",
  null
  
)

export default component.exports